import { createStore } from 'zustand'
import { StatsThemeStore } from './types'
import { getEnabledStatsThemes, getStatsTheme } from '../utils'
import { StatsThemeId } from '../types'

const DEFAULT_THEME = 'pink'
const ENABLED_THEMES: StatsThemeId[] = [
  'pink',
  'blue',
  'green',
  'dark_green',
  'dark_pink',
]

export const createStatsThemeStore = () => {
  return createStore<StatsThemeStore>()((set, get) => ({
    theme: getStatsTheme(DEFAULT_THEME),
    currentTheme: DEFAULT_THEME,
    enabledThemes: getEnabledStatsThemes(ENABLED_THEMES),
    setTheme: (id) => {
      const { enabledThemes } = get()

      const themeExists = enabledThemes.find((theme) => theme.id === id)

      if (!themeExists) {
        console.warn(`Theme "${id}" not found. Using default theme instead.`)

        const unknownId = id as unknown

        if (unknownId === 'dark') {
          const defaultDarkTheme = 'dark_green'

          set({
            theme: getStatsTheme(defaultDarkTheme),
            currentTheme: defaultDarkTheme,
          })
          return
        }

        const defaultThemeId = 'pink'

        set({
          theme: getStatsTheme(defaultThemeId),
          currentTheme: defaultThemeId,
        })
        return
      }

      set({ theme: getStatsTheme(id), currentTheme: id })
    },
  }))
}
